import { i18n } from '@shared/i18n';
import _values from 'lodash/values';

class Roles {
  static get values() {
    return {
      admin: 'admin',
      editor: 'editor',
      viewer: 'viewer',
      auditLogViewer: 'auditLogViewer',
      iamSecurityReviewer: 'iamSecurityReviewer',
      entityEditor: 'entityEditor',
      entityViewer: 'entityViewer',
      propertyManager: 'propertyManager',
      subpropertyManager: 'subpropertyManager',
      programManager: 'programManager',
      subprogramManager: 'subprogramManager',
      academyManager: 'academyManager',
      tournamentManager: 'tournamentManager',
      schoolManager: 'schoolManager',
      leagueManager: 'leagueManager',
      newsletterEditor: 'newsletterEditor',
      newsletterViewer: 'newsletterViewer',
      commentEditor: 'commentEditor',
      commentViewer: 'commentViewer',
      // academyEditor: 'academyEditor',
      // academyViewer: 'academyViewer',
      // playerEditor: 'playerEditor',
      // playerViewer: 'playerViewer',
      // propertySettingEditor: 'propertySettingEditor',
      // propertySettingViewer: 'propertySettingViewer',
      // coachEditor: 'coachEditor',
      // coachViewer: 'coachViewer',
      // parentEditor: 'parentEditor',
      // parentViewer: 'parentViewer',
      // newsEditor: 'newsEditor',
      // newsViewer: 'newsViewer',
      // trainingEditor: 'trainingEditor',
      // trainingViewer: 'trainingViewer',
      // gameEditor: 'gameEditor',
      // gameViewer: 'gameViewer',
      // eventEditor: 'eventEditor',
      // eventViewer: 'eventViewer',
      // teamEditor: 'teamEditor',
      // teamViewer: 'teamViewer',
      // positionEditor: 'positionEditor',
      // positionViewer: 'positionViewer',
      // fanEditor: 'fanEditor',
      // fanViewer: 'fanViewer',
      // sheetEventEditor: 'sheetEventEditor',
      // sheetEventViewer: 'sheetEventViewer',
      // siteEditor: 'siteEditor',
      // siteViewer: 'siteViewer',
      // clubEditor: 'clubEditor',
      // clubViewer: 'clubViewer',
      // serviceEditor: 'serviceEditor',
      // serviceViewer: 'serviceViewer',
      // propertyEditor: 'propertyEditor',
      // propertyViewer: 'propertyViewer',
      // categoryEditor: 'categoryEditor',
      // categoryViewer: 'categoryViewer',
      // programEditor: 'programEditor',
      // programViewer: 'programViewer',
    };
  }

  static labelOf(roleId) {
    if (!this.values[roleId]) {
      return roleId;
    }

    return i18n(`roles.${roleId}.label`);
  }

  static descriptionOf(roleId) {
    if (!this.values[roleId]) {
      return roleId;
    }

    return i18n(`roles.${roleId}.description`);
  }

  static get selectOptions() {
    return _values(this.values).map((value) => ({
      id: value,
      value: value,
      title: this.descriptionOf(value),
      label: this.labelOf(value),
    }));
  }
}

export default Roles;
